import React from 'react'
import { Alert, StackView } from '@planningcenter/tapestry-react'
import { Code, Link, List, PageHeading, Text } from '../../../shared/typography'

export default function page() {
  return (
    <StackView axis="vertical" spacing={2}>
      <PageHeading>Sample Apps</PageHeading>

      <Text>
        Below are example applications that demonstrate how to obtain and use
        access tokens and refresh tokens with OAuth's Authorization Code Flow
        and the PKCE extension. They also show how to use OpenID Connect (OIDC)
        to authenticate users and retrieve their profile information.
      </Text>

      <List>
        <List.Item>
          <Link
            to="https://github.com/planningcenter/pco_api_oauth_example_flask_python"
            external
          >
            Flask + Python
          </Link>
        </List.Item>
        <List.Item>
          <Link
            to="https://github.com/planningcenter/pco_api_oauth_example_sinatra_ruby"
            external
          >
            Sinatra + Ruby
          </Link>
          <List>
            <List.Item>
              Also includes a fully client-side OAuth + PKCE demo implemented
              directly{' '}
              <Link
                to="https://github.com/planningcenter/pco_api_oauth_example_sinatra_ruby/blob/main/views/login.erb"
                external
              >
                in a <Code>script</Code> tag on this page
              </Link>
              .
            </List.Item>
          </List>
        </List.Item>
        <List.Item>
          <Link
            to="https://github.com/planningcenter/pco_api_oauth_example_slim_php"
            external
          >
            Slim + PHP
          </Link>
        </List.Item>
      </List>

      <Alert type="success" marginBottom={2}>
        <Text size={4}>
          <strong>NOTE:</strong> For OIDC it is highly recommended to use a{' '}
          <Link
            to="https://openid.net/developers/certified-openid-connect-implementations/"
            external
          >
            client library for your language
          </Link>{' '}
          that can handle the complexities of the protocol. Some examples are{' '}
          <Code>oidc-client</Code>
          for Python, <Code>php-openid-client</Code> for PHP, and{' '}
          <Code>openid_connect</Code> for Ruby.
        </Text>
      </Alert>
    </StackView>
  )
}
